export const handleReload = () => {
  window.location.assign('/')
}

export const messages = {
  reloadButtonLabel: 'Reload App',
  reloadText: 'Please reload the app by clicking the button below.',
} as const
